import ENGLISH_MESSAGES from '../resources/en.json'
import SPANISH_MESSAGES from '../resources/es.json'

const getLanguageMessages = (language: string) => {
  switch (language) {
    case 'es':
      return SPANISH_MESSAGES
    case 'en':
      return ENGLISH_MESSAGES
    default:
      return ENGLISH_MESSAGES
  }
}

export default getLanguageMessages
